<script>
    export let list;

    export let components;

    const toggleComponent = (idTovar, e) => {
        if (e.target.checked) {
            components[idTovar] = {count: 1};
        } else {
            let { [idTovar]: _, ...obj } = components;
            components = obj;
        }
    };

    const setComponentCount = (idTovar, e) => {
        components[idTovar]['count'] = +(e !== null ? e.target.value : 1);
    };
</script>

<style>
    div.row .row {
        min-height: 63px;
    }
    div.row-scroller {
        max-height: 350px;
        overflow-y: scroll;
        overflow-x: hidden;
    }
    div.row-scroller::-webkit-scrollbar {
        width: 10px;
    }
    div.row-scroller::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    div.row-scroller::-webkit-scrollbar-thumb {
        background: rgba(108, 124, 148, 0.15);
    }
    div.row-scroller::-webkit-scrollbar-thumb:hover {
        background: #6C7C94;
    }
</style>

<div class="row">
    <div class="col-12">
        <div class="row align-items-center border-bottom" style="padding-right: 10px;">
            <div class="col-12 ps-0">Дополнительно:</div>

        </div>
    </div>

    {#each list.sort((a, b) => a.poryadok - b.poryadok) as item}
        <div class="col-12 row-scroller">
            <div class="row pb-3 align-items-center">
                <div class="col-6">
                    {item.name}


                </div>
                <div class="col-1 text-center">
                    <div class="btn-group">
                        <input type="checkbox" class="btn-check" bind:checked={components[item.idTovar]} on:change={(e) => toggleComponent(item.idTovar, e)} id="tovar-{item.idTovar}">
                        <label class="btn btn-icon btn-sm btn-outline-primary" for="tovar-{item.idTovar}">
                            {#if components.hasOwnProperty(item.idTovar)}
                                <i class="fas fa-check"></i>
                            {/if}
                        </label>
                    </div>
                </div>
                <div class="col-3 text-center d-none align-middle">
                    {#if components.hasOwnProperty(item.idTovar)}
                        <input
                            type="number"
                            class="form-control text-center me-1"
                            data-id="{item.idTovar}"
                            on:keyup={(e) => setComponentCount(item.idTovar, e)}
                            on:change={(e) => setComponentCount(item.idTovar, e)}
                            autofocus
                            on:focus="{e => e.target.select()}"
                            bind:value={components[item.idTovar]['count']}
                            min="1"
                            style="height: 30px;"
                        />
                    {/if}
                </div>
                <div class="col-2 text-end d-none text-nowrap">{(+item.price).toLocaleString()}</div>
            </div>
        </div>
    {/each}
</div>
